module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_troms_og_finnmark_pos.001147ec.svg";